import { useEffect, useState } from "react";
import { ObtenerMisPermisos } from "../Service/Service.me";

// RP-07 seccion 23-27: helper minimo reutilizable -- consume los permisos
// EFECTIVOS del actor desde el backend (GET /me/permissions), nunca los
// deriva de nivel_user_id. El backend sigue siendo la unica autoridad real
// (RequirePermission revalida siempre); esto solo evita que la UI muestre
// acciones que de todas formas serian rechazadas.
//
// Mientras `loading` es true, `hasPermission(...)` devuelve false para
// CUALQUIER permiso -- fail-closed visual (seccion 27): una accion sensible
// nunca aparece habilitada antes de conocer el permission set real.
export default function usePermissions() {
  const [permissions, setPermissions] = useState(null); // null mientras no se conoce aun
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        const res = await ObtenerMisPermisos();
        if (!cancelado && res && res.success) {
          setPermissions(new Set(res.data.permissions || []));
        } else if (!cancelado) {
          setError(res?.message || "No se pudieron obtener los permisos del usuario.");
        }
      } catch (e) {
        // AUDITORIA-CLINICA-BOTON-CORREGIR-FIX-43: sin este catch el rechazo
        // escapaba como unhandled rejection y `permissions` quedaba en null
        // para siempre -> TODA accion condicionada por permiso desaparecia de
        // la UI de forma indistinguible de "no tiene permiso", sin ninguna
        // señal. Se mantiene el fail-closed (nunca se otorga permiso ante un
        // fallo), pero el fallo deja de ser invisible.
        if (!cancelado) setError(e?.message || "Error al obtener los permisos del usuario.");
        console.error("usePermissions: no se pudieron cargar los permisos del actor:", e);
      } finally {
        if (!cancelado) setLoading(false);
      }
    })();
    return () => { cancelado = true; };
  }, []);

  const hasPermission = (permissionName) => {
    if (loading || !permissions) return false;
    return permissions.has(permissionName);
  };

  return { permissions, loading, error, hasPermission };
}
